import { useGLTF } from '@react-three/drei'

var url = './3DModels/Design_Ch/Design_Ch.gltf';

export default function Character(props) {
    const { nodes } = useGLTF(url)

    return(
        <>

            <mesh
                scale = {[10.0,10.0,10.0]}
                position={[0.02,-0.16,0.58]}
                rotation={[-1.57,0,1.57]}
                geometry={nodes.BRAND_LOGO016003.children[0].geometry}
         
            >

                <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />


            </mesh>

            <mesh
                scale = {[10.0,10.0,10.0]}
                position={[0.02,-0.16,0.58]}
                rotation={[-1.57,0,1.57]}
                geometry={nodes.BRAND_LOGO016003.children[1].geometry}
         
            >

                <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />


            </mesh>
        </>
    )

}

useGLTF.preload(url)

